import { CheckCircleOutlined, TruckOutlined } from '@ant-design/icons';
import { useTheme } from '@material-ui/core';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { Card } from '@portal/models/bank';
import { translate } from '@portal/services/i18n';
import React from 'react';
import './CardReceivedBanner.less';

export interface CardReceivedBannerProps {
  card: Card;
  onConfirmReceived: (cardId: string) => void;
  onViewTracking: (cardId: string) => void;
  loading?: boolean;
}

const CardReceivedBanner = ({
  card,
  onConfirmReceived,
  onViewTracking,
  loading = false,
}: CardReceivedBannerProps) => {
  const theme = useTheme();

  const handleConfirmReceived = () => {
    if (card.id) {
      onConfirmReceived(card.id);
    }
  };

  const handleViewTracking = () => {
    if (card.id) {
      onViewTracking(card.id);
    }
  };

  return (
    <div className="card-received-banner">
      <div
        className="card-received-banner__icon"
        style={{ color: theme.palette.info?.main }}
      >
        <TruckOutlined />
      </div>
      <div className="card-received-banner__content">
        <div className="card-received-banner__header">
          <ThemedText variant="h4" className="card-received-banner__title">
            {translate(
              'PAGES.CARDS.MY_CARDS.DETAILS.CARD_RECEIVED_BANNER.TITLE'
            )}
          </ThemedText>
          <ThemedText className="card-received-banner__subtitle">
            {translate(
              'PAGES.CARDS.MY_CARDS.DETAILS.CARD_RECEIVED_BANNER.SUBTITLE'
            )}
          </ThemedText>
        </div>
        <div className="card-received-banner__actions">
          <AdvancedButton
            variant="outlined"
            text={translate(
              'PAGES.CARDS.MY_CARDS.DETAILS.CARD_RECEIVED_BANNER.VIEW_TRACKING'
            )}
            onClick={handleViewTracking}
            disabled={loading}
          />
          <AdvancedButton
            variant="contained"
            text={translate(
              'PAGES.CARDS.MY_CARDS.DETAILS.CARD_RECEIVED_BANNER.CONFIRM_RECEIVED'
            )}
            onClick={handleConfirmReceived}
            loading={loading}
            endIcon={<CheckCircleOutlined />}
          />
        </div>
      </div>
    </div>
  );
};

export default CardReceivedBanner;
